module.exports = __webpack_public_path__ + "img/main_header_bgimg_202503_02.b401530a.png";